export default function activeSpliter (leftMin = 100, rightMin = 100) {
  let spliter = document.getElementById('spliter');
  let leftBlock = document.getElementById('leftBlock');
  let rightBlock = document.getElementById('rightBlock');
  spliter.onmousedown = function (e) {
    let startX = e.clientX;
    let leftWidth = leftBlock.offsetWidth, rightWidth = rightBlock.offsetWidth;
    document.onmousemove = function (ev) {
      let diff = ev.clientX - startX;
      if (leftMin < (leftWidth + diff) && rightMin < (rightWidth - diff)) {
        leftBlock.style.width = (leftWidth + diff) + 'px';
        spliter.style.left = (leftWidth + diff) + 'px';
        rightBlock.style.left = (leftWidth + diff) + 'px';
        rightBlock.style.width = (rightWidth - diff) + 'px';
      }
    }
    document.onmouseup = function () {
      document.onmousemove = null;
      document.onmouseup = null;
      spliter.releaseCapture && spliter.releaseCapture();
    }
    spliter.setCapture && spliter.setCapture();
    return false;
  }
}